import { createApp } from 'vue'
import VarianceCalculator from './VarianceCalculator.vue'
import './assets/global.css'

createApp(VarianceCalculator).mount('#variance')
